import { MutationTree } from 'vuex'
import { UserState } from '../types'
import setUserState from './setUserState'
import setShowNotificationMobile from './setShowNotificationMobile'
import setUserDisabledSoundNotifications from './setUserDisabledSoundNotifications'
import setUserDisabledTextNotifications from './setUserDisabledTextNotifications'

const mutations: MutationTree<UserState> = {
  setUserState,
  setShowNotificationMobile,
  setUserDisabledSoundNotifications,
  setUserDisabledTextNotifications,
}

export default mutations
